import axios from "axios";
import { toast } from "react-toastify";
import { LOGIN_USER } from "../../types/UserType";

const addUserAction = (data) => {
	return {
		type: LOGIN_USER,
		payload: data,
	};
};

export const loginWithCode = (values) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/login-with-code`,
				data: {
					email: values.email,
					code: values.code,
				},
			});
			
			//dispatching data
			dispatch(addUserAction(data));
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("role", data.role);
			localStorage.setItem("user", data.username);
			localStorage.setItem("id", data.id);
			if (data.company_id != null) localStorage.setItem("company_id", data.company_id);
			localStorage.setItem("isLogged", true);
			localStorage.setItem("isRequired", data.isRequired ? "true" : "false");
			
			if (data.isRequired) {
				toast.info("Please change your password to continue.");
			} else {
				toast.success("Login successful!");
			}
			
			return { success: "success", isRequired: data.isRequired };
		} catch (error) {
			console.log(error.message);
			const errorMessage = error.response?.data?.message || "Invalid code. Please try again.";
			toast.error(errorMessage);
			return { success: "error" };
		}
	};
};
